import { ANALYTICS_VIEW_ATTR } from '@/_constants/analytics-attrs';
import { TAnalyticEventParams } from '../../_types';

type TProps = {
  name: string;
  params?: Partial<TAnalyticEventParams>;
};

type TReturn = {
  [ANALYTICS_VIEW_ATTR]: string;
};

export const getAnalyticsViewAttr = (props: TProps): TReturn => ({
  [ANALYTICS_VIEW_ATTR]: JSON.stringify(props),
});
